import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_legacy_icon = _resolveComponent("legacy-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["funeral-plan-tab-image legacy-white-round-button page-title-icon", {'prevent': _ctx.isPrevent, 'lost-someone': !_ctx.isPrevent}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isPrevent)
        ? (_openBlock(), _createBlock(_component_legacy_icon, {
            key: 0,
            icon: "prevent-icon"
          }))
        : (_openBlock(), _createBlock(_component_legacy_icon, {
            key: 1,
            icon: "cross"
          }))
    ])
  ], 2))
}